import Vue from 'vue'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate, {
  inject: false,
  fieldsBagName: 'veeValidateFields', // changed because of property conflicts
  aria: true
})
